module.exports = __webpack_public_path__ + "images/emoji/smiling_imp.75aa99db075a80cb9142.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smiling_imp.png
// module id = xSp2
// module chunks = 14